import { createContext, useContext, useState } from 'react';

const CurrencyContext = createContext(null);

// Foreign (non-Indian) pricing = 4x the INR price, expressed in the foreign
// currency's natural magnitude (INR/100), ending in .99 for a premium feel.
// e.g. ₹499 -> $19.99, ₹12,496 -> $499.99
export function formatPrice(inr, currency) {
  const n = Number(inr) || 0;
  if (currency === 'USD') {
    const usd = Math.floor((n * 4) / 100) + 0.99;
    return `$${usd.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
  return `\u20B9${n.toLocaleString('en-IN')}`;
}

// India -> INR, everywhere else -> USD. Uses the device timezone (primary,
// survives language changes) with the browser locale as a fallback.
export function detectCurrency() {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    if (/Kolkata|Calcutta/i.test(tz)) return 'INR';
    if (tz) return 'USD';
  } catch { /* Intl unavailable */ }
  const locale = (navigator.language || '').toUpperCase();
  return locale.endsWith('-IN') ? 'INR' : 'USD';
}

export function CurrencyProvider({ children }) {
  const [currency, setCurrencyState] = useState(() => localStorage.getItem('currency') || detectCurrency());

  const setCurrency = (c) => {
    setCurrencyState(c);
    localStorage.setItem('currency', c);
  };

  const format = (inr) => formatPrice(inr, currency);

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, format }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyContext);
